<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-confirm-dialog-panel tenga la fascia panna a filo del bordo
     inferiore. -->
<h2 mat-dialog-title>Salva fattura come Bozza</h2>

<mat-dialog-content>
  <p class="izy-confirm-question">Vuoi finalizzare la fattura?</p>

  <!-- Nessuna spunta obbligatoria qui: salvare una bozza non distrugge e non
       invia niente, quindi il "Confermo" resta sempre attivo. La spunta e' il
       cancello delle conferme che hanno un effetto verso l'esterno. -->
  <p class="izy-confirm-message">
    Per il momento non verrà inviata all'esterno. Potrai rivederla e modificarla
    quando vuoi nel menù <strong>Bozze salvate</strong>, vedere l'anteprima del
    PDF ed eventualmente pubblicarla.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>close</mat-icon>
    Indietro
  </button>

  <button
    mat-raised-button
    matButton="filled"
    type="button"
    class="ms-2 izy-button-primary custom-button-border"
    (click)="confirm()">
    <mat-icon>check</mat-icon>
    Confermo
  </button>
</mat-dialog-actions>
